import { createSelector } from 'reselect';

import getAllDocuments from './getAllDocuments';
import { DocumentGarmentPlacementType } from 'src/types/decorationSpecs';

/** Every document's `GARMENT_WARP` placement inputs, flattened with the document's id — mirrors
 * `getAllGarmentMarkers`, but over documents rather than backgrounds (and `getAllCylinderWarps`,
 * which the same document-level `{ id, ...field }` flattening pattern comes from). Used when
 * saving a scene to collect the placements that ride in the revision's
 * `metadata.garmentPlacements` side-channel (see `src/services/converters/garmentPlacement.ts`). */
const getAllGarmentPlacements = createSelector([getAllDocuments], (documents) =>
    documents
        .filter((doc) => doc.garmentPlacement)
        .map((doc) => ({ id: doc.id, ...doc.garmentPlacement }) as DocumentGarmentPlacementType),
);

export default getAllGarmentPlacements;
